import jsPsychFullscreen from '@jspsych/plugin-fullscreen';

const sentryFeedback = document.querySelector('#sentry-feedback');

export const enter_fullscreen = {
  type: jsPsychFullscreen,
  fullscreen_mode: true,
  message: `<div class = 'text_div'><h1>The game will switch to full screen mode. <br> Click the button to continue. </h1></div>`,
  button_label: 'Go',
  on_start: () => {
    // Hide sentry feedback button
    if (sentryFeedback) {
      sentryFeedback.style.display = 'none';
    }
  },
};

export const exit_fullscreen = {
  type: jsPsychFullscreen,
  fullscreen_mode: false,
  delay_after: 0,
};
